export const currentPath = () =>
  typeof window !== 'undefined' ? window.location.pathname : ''

// path は `/hoge/` という形式の文字列を入れる
export const buildLangPath = (path: string, lang: string) =>
  lang === 'ja' ? path : `/${lang}${path}`
